import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PotionAttemptDisplay, type PotionAttempt } from './PotionAttemptDisplay';

interface GameWinScenarioProps {
  potionAttempts: PotionAttempt[];
  onHome: () => void;
  className?: string;
}

export const GameWinScenario: React.FC<GameWinScenarioProps> = ({ 
  potionAttempts, 
  onHome, 
  className = '' 
}) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    onHome();
    navigate('/');
  };

  return (
    <div className={`flex flex-col items-center justify-center min-h-screen bg-transparent text-white ${className}`}>
      {/* Magical Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating magical particles */}
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-bounce"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          >
            ✨
          </div>
        ))}
        
        {/* Removed sparkle overlay for cleaner look */}
        <div className="hidden" />
      </div>

      {/* Victory Header - positioned at 15vh */}
      <div className="absolute top-0 left-0 right-0 z-10 flex flex-col items-center text-center space-y-4" style={{ marginTop: '15vh' }}>
        <div className="text-6xl animate-bounce">⭐</div>
        <h1 className="text-7xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent px-6 py-4">
          MASTER OF LOVE!
        </h1>
        <p className="text-xl text-pink-200 font-medium">
          You are a master of love!
        </p>
      </div>

      {/* Main Content - positioned at 60vh */}
      <div className="absolute left-0 right-0 z-10 bg-gray-800 flex flex-col items-center space-y-8 p-8" style={{ marginTop: '50vh' }}>
        {/* Potion Attempts Display */}
        <div className="space-y-6">
          <div className="flex justify-center items-center space-x-16">
            {potionAttempts.map((attempt) => (
              <div key={attempt.attemptNumber} className="flex flex-col items-center">
                <PotionAttemptDisplay 
                  attempt={attempt} 
                  displayMode="win"
                  className="transform hover:scale-105 transition-transform duration-300"
                />
                
                {/* Success Indicator */}
                {attempt.result.isLovePotion && (
                  <div className="mt-2 text-yellow-300 animate-pulse font-bold">
                    ⭐ SUCCESS! ⭐
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="flex space-x-6">
          <button
            onClick={handleHomeClick}
            className="px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold text-lg rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            🏠  ホーム
          </button>
        </div>
      </div>
    </div>
  );
};